<template>
<div v-if="!redirectToThirdParty">
    <p id="mpgs-loading-message" class="text-center my-3" style="-webkit-animation: blinker 0.5s linear infinite;animation: blinker 0.5s linear infinite;">Loading please wait..</p>
    <div class="selectbank adselect">
        <div class="row">
            <form class="col">
                <div class="row">
                    <div class="input-field cardnumb">
                        <span class="cdnumber" for="icon_prefix">Card Number</span>
                        <img src="/mtn/assets/card.svg" alt="" class="ccv-icon b">
                        <input placeholder="XXXX XXXX XXXX XXXX" type="number" class="validate carddet" onKeyPress="if(this.value.length==16) return false;" id="card_cc" readonly />
                    </div>
                </div>
                <div class="row add-new-card">
                    <div class="input-field col s4 col-expiry">
                        <span class="expiry" for="first_name">Date</span>
                        <img src="/mtn/assets/date.svg" alt="" class="ccv-icon">
                        <input placeholder="MM" id="card_exp_month" type="number" pattern="(?:0[1-9]|1[0-2])/[0-9]{2}" onKeyPress="if(this.value.length==2) return false;" class="validate carddet" readonly />
                    </div>

                    <div class="input-field col s4 col-expiry">
                        <span class="expiry" for="first_name">Year</span>
                        <img src="/mtn/assets/date.svg" alt="" class="ccv-icon">
                        <input placeholder="YY" id="card_exp_year" type="number" pattern="(?:0[1-9]|1[0-2])/[0-9]{2}" onKeyPress="if(this.value.length==2) return false;" class="validate carddet" readonly />
                    </div>
                    <div class="input-field col s4 col-expiry ccv">
                        <span class="expiry" for="first_name">CCV</span>
                        <img src="/mtn/assets/lock.svg" alt="" class="ccv-icon">
                        <input placeholder="XXX" id="card_cvv" type="number" pattern="(?:0[1-9]|1[0-2])/[0-9]{2}" onKeyPress="if(this.value.length==3) return false;" class="validate carddet" readonly />
                    </div>

                </div>
            </form>
        </div>
    </div>

    <p class="saveoption" v-if="showToken">
        <label v-if="enforce_tokenization">
            <input type="checkbox" checked disabled id="tokenize-card" />
            <span class="para">Save this Option for future use</span>
        </label>

        <label v-else>
            <input type="checkbox" id="tokenize-card" />
            <span class="para">Save this Option for future use</span>
        </label>
    </p>

    <slot name="amount" />

    <button v-if="mpgsIsReady" @click.prevent="this.$emit('triggerPayment')" class=" viabutton submit modal-trigger modal-close">Proceed</button>

</div>

<div v-else class="text-center">
    <p class="mb-3" style="margin-top:70px;">You will be redirected to your card's issuer's verification page to authorize this payment</p>
    <!-- <button type="submit" class="viabutton submit mb-3" @click.prevent="visitThirdParty">Proceed</button>
        <a href="javascript:void(0)" class="change-option" @click.prevent="cancelRedirect"> Cancel </a> -->
</div>
</template>

<script>
export default {
    props: {
        scriptLoaded: {
            type: Object,
            required: true,
        },
        redirectToThirdParty: {
            type: Object,
            required: true,
            default: false,
        },
        extras: {
            type: Object,
            required: true,
        },
        mpgsSdkUrl : {
            type : String,
            required: true,
        }
        
    },
    destroyed() {
        let el = document.querySelector(`script[src='${this.mpgsSdkUrl}']`);
        if (el) {
            el.remove();
        }
    },

    updated() {
        // Look for a way to prevent re initialization
        if (!this.loading) {
            if (this.showToken && !this.enforce_tokenization) {
                if (this.checkToken)
                    if (document.getElementById('tokenize-card')) {
                        document.getElementById('tokenize-card').checked = true;
                    }
            }

            this.updatedIntegration();

        } else { // know that user is calling OnePipe
            if (this.isCallingOnePipe) {
                PaymentSession.updateSessionFromForm('card');
            }
        }

    },

    data() {
        return {
            card_cc_hover: true,
            card_exp_year_hover: false,
            card_exp_month_hover: false,
            card_exp_hover: false,
            card_cvv_hover: false,
            showToken: false,
            loading:false,
            enforce_tokenization: false,
            checkToken: false,
            mpgsIsReady:false,
            removeMargin: false,
            provider: null,
        }
    },
    mounted() {

        this.provider = this.$store.state.provider;

        this.integration();

        $('#number').on('keypress change', (e) => {
            // console.log(e)
            $(this).val(function (index, value) {
                return value.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ');
            });
        });

        if (Object.keys(this.extras).includes("enforce_tokenization")) {
            if (this.extras.enforce_tokenization == "true") {
                this.showToken = true;
                this.enforce_tokenization = true;
            } else {
                if (Object.keys(this.extras).includes("allow_tokenization")) {
                    if (this.extras.allow_tokenization == "true") {
                        this.checkToken = true; // automatically check the tokenization box
                        this.showToken = true;
                    } else if (this.extras.allow_tokenization == "") {
                        this.checkToken = false;
                        this.showToken = true;
                    }

                }
            }
        }

    },
    methods: {
        pickCardToDelete(val) {
            this.$emit('pickCardToDelete', val);
        },
        handleAttemptCardRemoval(val) {
            this.$emit('handleAttemptCardRemoval', val);
        },
        gotoCardListing() {
            this.$emit('gotoCardListing');
        },
        triggerCardInput() {
            this.$emit('triggerCardInput');
        },
        triggerManageCard() {
            this.$emit('triggerManageCard');
        },

        isLoading(val = false) {
            this.$emit('isLoading', val);
        },
        integration() {
            this.scriptLoaded && this.scriptLoaded.then(() => {

                let vm = this;
                this.isLoading();

                if(PaymentSession)
                PaymentSession.configure({
                    fields: {
                        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
                        card: {
                            number: "#card_cc",
                            securityCode: "#card_cvv",
                            expiryMonth: "#card_exp_month",
                            expiryYear: "#card_exp_year"
                        }
                    },
                    //SPECIFY YOUR MITIGATION OPTION HERE
                    frameEmbeddingMitigation: ["javascript"],
                    callbacks: {
                        initialized: (response) => { // HANDLE INITIALIZATION RESPONSE
                            if (response.status == "ok") {
                                this.isLoading();
                                vm.removeMargin = true;
                                vm.mpgsIsReady = true;

                                if (document.getElementById('mpgs-loading-message')) {
                                    document.getElementById('mpgs-loading-message').style.display = 'none';
                                    vm.mpgsIsReady = true;
                                }
                            }
                        },
                        formSessionUpdate: (response) => { // HANDLE RESPONSE FOR UPDATE SESSION

                            if (response.status) {
                                if ("ok" == response.status) {
                                    vm.$emit('callOnePipe', response.session.id)
                                } else if ("fields_in_error" == response.status) {

                                    this.isLoading();

                                    if (response.errors.cardNumber) {
                                        vm.errors.card_cc = true
                                    }
                                    if (response.errors.expiryYear) {
                                        vm.errors.card_exp_year = true
                                    }
                                    if (response.errors.expiryMonth) {
                                        vm.errors.card_exp_month = true
                                    }
                                    if (response.errors.securityCode) {
                                        vm.errors.card_cvv = true;
                                    }

                                } else if ("request_timeout" == response.status) {
                                    alert("Session update failed with request timeout: " + response.errors.message);
                                } else if ("system_error" == response.status) {
                                    alert("Session update failed with system error: " + response.errors.message);
                                }
                            } else {
                                alert("Session update failed: " + response);
                            }
                        }
                    }
                });
            });
        },

        updatedIntegration() {
            this.scriptLoaded && this.scriptLoaded.then(() => {

                let vm = this;

                if(PaymentSession)
                PaymentSession.configure({
                    // window.PaymentSession.configure({
                    fields: {
                        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
                        card: {
                            number: "#card_cc",
                            securityCode: "#card_cvv",
                            expiryMonth: "#card_exp_month",
                            expiryYear: "#card_exp_year"
                        }
                    },
                    //SPECIFY YOUR MITIGATION OPTION HERE
                    frameEmbeddingMitigation: ["javascript"],
                    callbacks: {
                        initialized: (response) => { // HANDLE INITIALIZATION RESPONSE
                            if (response.status == "ok") {
                                vm.loading = false;
                                vm.removeMargin = true;
                                vm.mpgsIsReady = true;

                                if (document.getElementById('mpgs-loading-message')) {
                                    document.getElementById('mpgs-loading-message').style.display = 'none';
                                    vm.mpgsIsReady = true;
                                }
                            }
                        },
                        formSessionUpdate: (response) => { // HANDLE RESPONSE FOR UPDATE SESSION
                            if (response.status) {
                                if ("ok" == response.status) {
                                    vm.callOnePipe(response.session.id);
                                } else if ("fields_in_error" == response.status) {

                                    vm.loading = false;

                                    if (response.errors.cardNumber) {
                                        vm.errors.card_cc = true
                                    }
                                    if (response.errors.expiryYear) {
                                        vm.errors.card_exp_year = true
                                    }
                                    if (response.errors.expiryMonth) {
                                        vm.errors.card_exp_month = true
                                    }
                                    if (response.errors.securityCode) {
                                        vm.errors.card_cvv = true;
                                    }

                                } else if ("request_timeout" == response.status) {
                                    alert("Session update failed with request timeout: " + response.errors.message);
                                } else if ("system_error" == response.status) {
                                    alert("Session update failed with system error: " + response.errors.message);
                                }
                            } else {
                                alert("Session update failed: " + response);
                            }
                        }
                    }
                });
            });
        },
    },
}
</script>
